<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<app-pulsemenu></app-pulsemenu>
<div class="container2" *ngIf="doctor">
  <div class="row">
    <div class="com-sm-12 col-md-3 col-lg-3 col-xl-3 text-right">
        <img style="height:300px" src="https://passport.petcart.in/images/userimgs/{{doctor[0].photo}}" alt="image description">
    </div>
    <div class="com-sm-12 col-md-9 col-lg-9 col-xl-9 ">
        <div class="row">
         <div class="col-12 ">
            <h3 style="color:#9b7544" >{{doctor[0].name}}</h3>
         </div>
         <div class="col-12">
            <h3 style="color:#9b7544" >{{doctor[0].qualification}}</h3>
          </div>
          <div class="col-12">
             <h3 style="color:#9b7544" >
                {{doctor[0].experience}}
            </h3>
            </div>
            <div class="col-12">
              <div class="row">
               <div class="col-2" style="color:#9b7544" >
                  <mat-icon>place</mat-icon>
               </div>
               <div class="col-10" style="color:#9b7544">
                  {{doctor[0].address}}
                </div>
                </div>
                <div class="col-12">
                    <button class="btn btn-success btn-block" end clear style="margin-bottom: 1%"
                   (click)="bookAppointment(doctor[0].id)">Book Appointment</button>
                </div>
               </div>
        </div>
      </div>
  </div>
  <div class="card-header">
      About
    </div>
  <div class="row">
    <div class="col-12">
     <p>{{doctor[0].about}}</p>
    </div>
  </div>
  <div class="card-header">
      Qualification
    </div>
  <div class="row">
      <div class="col-12">
       <p>{{doctor[0].qualification}}</p>
      </div>
    </div>
    <div class="card-header">
        Experience
      </div>
    <div class="row">
        <div class="col-12">
         <p>{{doctor[0].experience}}</p>
        </div>
      </div>
      <div class="card-header">
          Education
        </div>
      <div class="row">
          <div class="col-12">
           <p>{{doctor[0].education}}</p>
          </div>
        </div>
        <div class="card-header">
            Experience Detail
          </div>
        <div class="row">
            <div class="col-12">
             <p>{{doctor[0].expdetail}}</p>
            </div>
          </div>
          <div class="card-header">
              Registration
            </div>
          <div class="row">
              <div class="col-12">
               <p>{{doctor[0].registration}}</p>
              </div>
            </div>
            <div class="card-header">
                Award
              </div>
            <div class="row">
                <div class="col-12">
                 <p>{{doctor[0].award}}</p>
                </div>
              </div>
              <div class="card-header text-ceter">
                  Membership
                </div>
              <div class="row">
                  <div class="col-12">
                   <p>{{doctor[0].membership}}</p>
                  </div>
                </div>
  <!--<div *ngIf="special2 && specialist">
    <div class="row" style="margin-top:4%; margin-left:1%; border-bottom:1px solid #9b7544">
        <h5><p style="overflow-wrap:break-word; font-style: open-sans">
          Specialisation
        </p></h5>
      </div>

    <div class="row">
        <div class="col-12 text-center">
          <table id="pctab" class="table table-bordered" class="table table-bordered"
          style="border-color:#cb983f,2px,solid" class="table table-bordered">
          <tr class="card-header">
              <th>index</th>
              <th>Specialisation name</th>
           </tr>
            <tr *ngFor="let a of special2; let i= index">
            <td>{{i+1}}</td>
            <td>{{a.name}}</td>
           </tr>
         </table>
        </div>
      </div>
    </div>-->

    <!--<div class="row" style="margin-top:4%; margin-left:1%; border-bottom:1px solid #9b7544">
        <h5><p style="overflow-wrap:break-word; font-style: open-sans">
          Listed Services
        </p></h5>
      </div>
<div *ngIf="services">
    <div class="row">
        <div class="col-12 text-center">
          <table  style="border-color:#cb983f,2px,solid" class="table table-bordered">
          <tr class="card-header">
              <th>index</th>
              <th>service name</th>
              <th>Fees</th>
           </tr>
           <tbody>
           <div *ngFor=" let s of finalfees , let i= index">
             <div *ngFor="let a of services">
                <tr>
                    <td  *ngIf="s.service_id == a.id">{{i + 1}}</td>
                    <td  *ngIf="s.service_id == a.id"> {{a.name}}</td>
                    <td  *ngIf="s.service_id == a.id"> Rs. {{s.fees}}</td>
                 </tr>
             </div>
           </div>
          </tbody>
         </table>
        </div>
      </div>
    </div>-->
    <mat-card>
      <mat-card-content>

    <div *ngIf="special2 && specialist">
      
                  <div>
      
                      <h1 style='margin-left: 0px; color:#9b7544'>Specialisation name</h1>
                  </div> <br>
                    <span style=" background-color: #dbd3be;  padding: 10px; border-radius: 10px; margin: 0 5px 0 0; line-height: 45px" *ngFor="let a of special2; let i= index">
      
      
                        {{a.name}}
      
                      </span>
      
            </div>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content>

            <div *ngIf="servicemenu && servicemenu.length > 0">
              <div>

                 <h1 style="color:#9b7544;"> Services </h1>
              </div> <br>
               <span *ngFor = 'let s of services'>
               <span *ngFor = 'let sp of finalfees'>

                     <span style="    background-color: #dbd3be;  padding: 10px; border-radius: 10px; margin: 0 5px 0 0; line-height: 45px" *ngIf='s.id === sp.service_id'>
                        {{s.name}}
                     </span>


                   </span>
                 </span>

       </div>
      </mat-card-content>
    </mat-card>


</div>
